import * as fromUser from '@components/user-profile/store/user.reducer';
import { ActionReducerMap } from '@ngrx/store';

export interface AppState {
    user: fromUser.UserState;
  }
  
  export const APP_REDUCER: ActionReducerMap<AppState> = {
    user: fromUser.USER_REDUCER
  };